import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Settings } from "components/shared/icons/settings"
import { Button } from "components/shared/landing/button"
import { Text } from "components/shared/text"

import { getPercentValue } from "utils/get-percent-value"

import styles from "./percent-stat.module.scss"

export type PercentStatProps = {
  currentDamage?: number
  total?: number
  durabilityClick?: () => void
  possibleToFix?: boolean
}

export function PercentStat({ currentDamage, total, durabilityClick, possibleToFix }: PercentStatProps) {
  const { isMobile } = useTailwindBreakpoints()
  const definedTotal = typeof total === "undefined" ? 100 : total
  const current = typeof currentDamage === "undefined" ? 100 : definedTotal - currentDamage
  const percent = getPercentValue(current, definedTotal)
  const broken = current < definedTotal
  return (
    <Box
      row
      className="w-full rounded p-2 bg-[#4F4ACC80] mb-3 gap-3 items-center lg:rounded-2xl lg:px-3 lg:py-4 lg:mb-8"
    >
      {broken && durabilityClick ? (
        <Button
          noPadding
          noVolume
          disabled={!possibleToFix}
          type="transparent"
          className={`shrink-0 bg-[#A455FF] z-1 p-1`}
          onClick={durabilityClick}
        >
          <Settings h={isMobile ? 18 : 28} w={isMobile ? 18 : 28} />
        </Button>
      ) : (
        <Settings h={isMobile ? 18 : 28} w={isMobile ? 18 : 28} />
      )}

      <Box className="w-full">
        <Text className="text-white" size={isMobile ? "sm" : "lg"} weight="bold">
          {current}/{definedTotal}
        </Text>
        <Box row className="w-full h-[8px] flex rounded-lg bg-[#0000007D] border-2 border-[#21174C]">
          <span className={`${styles["percent-stat_gradient"]} rounded-lg`} style={{ width: `${percent}%` }} />
        </Box>
      </Box>
    </Box>
  )
}
